import { render, staticRenderFns } from "./Loteamento.vue?vue&type=template&id=12fff988"
import script from "./Loteamento.vue?vue&type=script&lang=js"
export * from "./Loteamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports